<form class="form-box login-form form-validator md-form" [formGroup]="addressForm">

    <!--Grid row-->
    <div class="row">
      <!--Grid column-->
      <div class="col-md-6">
        <!--firstName-->
        <div class="md-form">
          <input
            type="text"
            id="firstName"
            class="form-control"
            formControlName="firstName"
            [attr.data-testid]="scope + '-first-name-input'"
            mdbInput
            mdbValidate
          />
          <mdb-error *ngIf="hasError('firstName', 'required')">First Name is required</mdb-error>
          <mdb-error *ngIf="hasError('firstName', 'minlength') || hasError('firstName', 'pattern')">First Name must be only letters, spaces, hyphens, apostrophes or dots.</mdb-error>
          <label for="firstName" class="">First name</label>
        </div>
      </div>
      <!--Grid column-->

    <!--Grid column-->
    <div class="col-md-6">
      <!--lastName-->
      <div class="md-form">
        <input 
            type="text" 
            id="lastName" 
            class="form-control" 
            formControlName="lastName"
            [attr.data-testid]="scope + '-last-name-input'"
            mdbInput 
            mdbValidate 
        />
        <mdb-error *ngIf="hasError('lastName', 'required')">Last Name is required</mdb-error>
        <mdb-error *ngIf="hasError('lastName', 'minlength') || hasError('lastName', 'pattern')">Last Name must be only letters, spaces, hyphens, apostrophes or dots.</mdb-error>
        <label for="lastName" class="">Last name</label>
      </div>
    </div>
    <!--Grid column-->
  </div>

  <div class="row">
    <!--Grid column-->
    <div class="col-md-6">
      <!--firstName-->
      <div class="md-form">
        <input 
            type="text" 
            id="company" 
            class="form-control" 
            formControlName="company"
            [attr.data-testid]="scope + '-company-input'"
            mdbInput 
            mdbValidate
        />
        <label for="company" class="">Company</label>
      </div>
    </div>
    <!--Grid column-->

    <!--Grid column-->
    <div class="col-md-6">
      <!--lastName-->
      <div class="md-form">
        <input 
            type="tel" 
            id="phone" 
            mask="(000) 000-0000x99999" 
            [specialCharacters]="['x','(',')',' ','-']" 
            [showMaskTyped]="false" 
            class="form-control" 
            formControlName="phone"
            [attr.data-testid]="scope + '-phone-input'"
            mdbInput 
            mdbValidate 
        />
        <mdb-error *ngIf="hasError('phone', 'required')">Phone is required</mdb-error>
        <mdb-error *ngIf="hasError('phone', 'mask')">Phone has incorrect format. Please use 10 digits. Continue typeing to enter an extension up to 5 digits long.</mdb-error>
        <label for="phone" class="">Phone</label>
      </div>
    </div>
    <!--Grid column-->
  </div>
  <!--Grid row-->

  <!--address-->
  <div class="md-form">
    <input 
        type="text" 
        id="address" 
        class="form-control" 
        [options]="googleOptions"
        formControlName="address"
        [attr.data-testid]="scope + '-address-input'"
        mdbInput 
        mdbValidate 
        ngxAutocomPlace 
        (selectedPlace)="addressChanged($event)"
    />
    <mdb-error *ngIf="hasError('address', 'required')">Address is required</mdb-error>
    <label for="address" class="">Address</label>
  </div>

  <!--Grid row-->
  <div class="row">
    <!--address-2-->
    <!--Grid column-->
    <div class="col-md-8">
      <!--Address 2nd line-->
      <div class="md-form">
        <input 
            type="text"
            id="address2" 
            class="form-control"
            formControlName="address2"
            [attr.data-testid]="scope + '-address2-input'"
            mdbInput 
            mdbValidate
        />
        <label for="address2" class="">Address 2nd line (i.e. Apt, Suite.)</label>
      </div>
    </div>
    <!--Grid column-->

    <!--Grid column-->
    <div class="col-md-4">
      <div class="md-form">
        <!--Country-->
        <mdb-select-2 
            class="w-100" 
            id="country" 
            placeholder="Choose.." 
            label="Country" 
            formControlName="country"
            mdbValidate
            (valueChange)="onCountryChange($event)"
            [attr.data-testid]="scope + '-country-select'"
        >
          <mdb-select-option *ngFor="let option of countryOptions" [value]="option.Value">{{
            option.Text
            }}</mdb-select-option>
        </mdb-select-2>
        <mdb-error *ngIf="hasError('country', 'required')">Please select a country</mdb-error>
      </div>
    </div>
    <!--Grid column-->
  </div>

  <!-- Material column sizing form -->

  <!-- Grid row -->
  <div class="form-row">
    <!-- Grid column -->
    <div class="col-5">
      <div class="md-form">
        <mdb-select-2 
            class="w-100" 
            id="province" 
            label="Province/State" 
            [disabled]="isProvincesLoading"
            placeholder="Choose.." 
            formControlName="province"
            [attr.data-testid]="scope + '-province-select'"
            mdbValidate
        >
          <mdb-select-option *ngFor="let option of provinceOptions" [value]="option.Value">{{
            option.Text
            }}</mdb-select-option>
        </mdb-select-2>
        <mdb-error *ngIf="hasError('province', 'required')">Please select a province/state</mdb-error>
      </div>
    </div>
    <!-- Grid column -->

    <!-- Grid column -->
    <div class="col">
      <!-- Material input -->
      <div class="md-form">
        <input 
            type="text"
            id="city" 
            class="form-control" 
            formControlName="city"
            [attr.data-testid]="scope + '-city-input'"
            mdbInput 
            mdbValidate 
        />
        <mdb-error *ngIf="hasError('city', 'required')">City is required</mdb-error>
        <label for="city" class="">City</label>
      </div>
    </div>

    <!-- Grid column -->

    <!-- Grid column -->
    <div class="col">
      <!-- Material input -->
      <div class="md-form">
        <input 
            type="text" 
            id="postalcode" 
            class="form-control" 
            formControlName="postalCode"
            [attr.data-testid]="scope + '-postal-code-input'"
            mdbInput 
            mdbValidate
        />
        <mdb-error *ngIf="hasError('postalCode', 'required')">Postal Code/Zip is required</mdb-error>
        <mdb-error *ngIf="hasError('postalCode', 'invalid')">Postal Code/Zip is invalid</mdb-error>
        <label for="postalcode" class="">Postal Code / Zip</label>
      </div>
    </div>
    <!-- Grid column -->
  </div>
  <!-- Grid row -->
</form>
